export default `





            [ ,█,█,█][█, ,█,█]      [ ,█,█,█][█, ,█,█]
            [█,█,█, ][█,█, ,█]      [█,█,█,█][█,█, , ]



            ██████████

`